import { DebugFeature, DebugStore } from "./debugTypes";

export function selectDebugFeatures({ debug }: DebugStore) {
    return debug.features
}

export const selectIsEnabled = (feature: DebugFeature) => ({ debug }: DebugStore) => {
    return debug.features[feature] ?? false
}
